//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PracticeLogUpdateItem extends ItemBase {
    Date?: string;
    Duration?: number;
    Note?: string | null;
    TeacherID?: string | null;
    AssignmentName?: string | null;

    constructor(initializer?: Partial<PracticeLogUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogUpdateItem";
}
